<template>
  <div v-if="!isEmpty" class="user-listing-detail">
    <div
      class="
        Head-div
        p-3
        d-flex
        justify-content-between
        align-items-center
        border-bottom
      "
    >
      <h4 class="mb-0">Hospital Details</h4>
      <div class="cursor" @click.stop="$emit('close')">
        <crossSVG />
      </div>
    </div>
    <CCol sm="12" class="px-0 inner-scroller">
      <!-- .... end user-profile-info ... -->
      <CCol sm="12" class="px-0 pb-0">
        <CCol sm="12" class="pt-0 border-bottom">
          <h6 class="mb-0 text-dark">Hospital Owner Details</h6>
        </CCol>
        <CCol sm="12" class="border-bottom">
          <CRow>
            <CCol sm="6" md="4">
              <p class="text-dark mb-0">
                Name : {{ centerData.created_by.full_name }}
              </p>
              <p></p>
            </CCol>
            <CCol sm="6" md="4">
              <p class="text-dark mb-0">
                Mobile Number : {{ centerData.created_by.mobile }}
              </p>
              <p></p>
            </CCol>
            <CCol sm="6" md="4">
              <p class="text-dark mb-0">
                Email :
                {{
                  centerData.created_by.email ? centerData.created_by.email : ""
                }}
              </p>
              <p></p>
            </CCol>
            <CCol sm="6" md="4">
              <p class="text-dark mb-0">
                Gender : {{ centerData.created_by.gender }}
              </p>
              <p></p>
            </CCol>
            <CCol sm="6" md="4">
              <p class="text-dark mb-0">
                DOB :
                {{
                  centerData.created_by.dob
                    ? centerData.created_by.dob
                    : centerData.created_by.estimated_dob | formatDate
                }}
              </p>
              <p></p>
            </CCol>
            <CCol sm="6" md="4">
              <p class="text-dark mb-0">
                Age :
                {{
                  centerData.created_by.dob
                    ? centerData.created_by.dob
                    : centerData.created_by.estimated_dob | age
                }}
              </p>
              <p></p>
            </CCol>
          </CRow>
        </CCol>
      </CCol>

      <!-- ================================== -->
      <!-- centre details start -->
      <!-- <CCol sm="12" class="p-0">
        <CCol sm="12" class="border-bottom">
          <h6 class="mb-0 text-dark">Staff Details</h6>
        </CCol>
        <CCol sm="12" class="border-bottom">
          <CRow>
            <CCol sm="6" md="2">
              <p class="text-dark mb-0"> Staff Name </p>
              <p>Saili Rawnang</p>
            </CCol>
            <CCol sm="6" md="2">
              <p class="text-dark mb-0"> Staff UserID</p>
              <p>sai123</p>
            </CCol>
            <CCol sm="6" md="2">
              <p class="text-dark mb-0"> Staff Mobile number</p>
              <p>
               1511551111
              </p>
            </CCol>
          </CRow>
        </CCol>
      </CCol> -->
      <!-- centre details end -->
      <!-- ================================== -->
      <CCol sm="12" class="px-0">
        <!-- .... Hospital Detail ... -->
        <CCol sm="12" class="p-0">
          <CCol sm="12" class="pt-0 border-bottom">
            <h6 class="mb-0 text-dark">Hospital Details</h6>
          </CCol>
          <CCol sm="12" class="border-bottom">
            <CRow>
              <CCol sm="6" md="4">
                <p class="text-dark mb-0">
                  No. of Beds : {{ centerData.hospital.beds }}
                </p>
                <p></p>
              </CCol>
              <CCol sm="6" md="4">
                <p class="text-dark mb-0">
                  Hospital Existing Since : {{ centerData.general.since }}
                </p>
                <p></p>
              </CCol>
              <CCol sm="6" md="4">
                <p class="text-dark mb-0">
                  Type : {{ centerData.hospital.hospital_type }}
                </p>
                <p></p>
              </CCol>
              <CCol sm="6" md="4">
                <p class="text-dark mb-0">
                  Speciality : {{ centerData.speciality_catering | speciality }}
                </p>
                <p></p>
              </CCol>
              <CCol sm="6" md="4">
                <p class="text-dark mb-0">
                  Emergency Service Type : Yes <span>(Medical Emergency)</span>
                </p>
                <p></p>
              </CCol>
              <CCol sm="6" md="4">
                <p class="text-dark mb-0">
                  hospital is a Daycare :
                  {{ centerData.hospital.day_care ? "Yes" : "No" }}
                </p>
                <p></p>
              </CCol>
              <CCol sm="6" md="4">
                <p class="text-dark mb-0">
                  Hospital Registration Number :
                  {{ centerData.hospital.registration_number }}
                </p>
                <p></p>
              </CCol>
              <CCol sm="6" md="4">
                <p class="text-dark mb-0">
                  Hospital Registration Certificate :
                  <button
                    type="button"
                    class="
                      view-certificate
                      v-btn v-btn--is-elevated v-btn--has-bg
                      theme--light
                      v-size--large
                    "
                    :disabled="
                      centerData.hospital.registration_proof_image
                        ? false
                        : true
                    "
                    @click="
                      openModal(
                        centerData.hospital.registration_proof_image,
                        'Certificate'
                      )
                    "
                  >
                    <span class="v-btn__content">View</span>
                  </button>
                </p>
                <p></p>
              </CCol>
              <CCol sm="6" md="4">
                <p class="text-dark mb-0">
                  Facilities : ({{
                    centerData.hospital.services_offered | services_offered
                  }})
                </p>

                <!-- <p>  -->
                <!-- <td
                    v-for="accreditations in centerData.hospital.services_offered"
                    :key="accreditations"
                  >{{accreditations}}</td> -->
                <!-- </p> -->
                <p></p>
              </CCol>
              <CCol sm="6" md="4">
                <p class="text-dark mb-0">
                  Is it a Standalone Hospital :
                  {{ centerData.hospital.standalone ? "Yes" : "No" }}
                </p>
                <p></p>
              </CCol>
              <CCol sm="6" md="4">
                <p class="text-dark mb-0">
                  Is Hospital a Teaching Institute for Doctors :
                  {{ centerData.hospital.training_institute ? "Yes" : "No" }}
                </p>
                <p></p>
              </CCol>
              <CCol sm="6" md="4">
                <p class="text-dark mb-0">
                  Cashless services for admission :
                  {{ centerData.hospital.is_cashless ? "Yes" : "No" }}
                  <button
                    type="button"
                    class="
                      view-hospital
                      v-btn v-btn--is-elevated v-btn--has-bg
                      theme--light
                      v-size--large ml-1
                    "
                    v-if="centerData.hospital.is_cashless"
                    @click="cashlessScheme = true"
                  >
                    <span class="v-btn__content">View</span>
                  </button>
                </p>
                <p></p>
              </CCol>
              <CCol sm="6" md="4">
                <p class="text-dark mb-0">
                  Government Health Scheme :
                  {{
                    centerData.hospital.is_government_health_scheme
                      ? "Yes"
                      : "No"
                  }}
                  <button
                    type="button"
                    class="
                      view-hospital
                      v-btn v-btn--is-elevated v-btn--has-bg
                      theme--light
                      v-size--large
                      ml-1
                    "
                    v-if="centerData.hospital.is_government_health_scheme"
                    @click="governmentHealthScheme = true"
                  >
                    <span class="v-btn__content">View</span>
                  </button>
                  <!-- <span v-for="(scheme, index) in centerData.hospital.government_health_schemes_data"
                :key="index">({{scheme.scheme}})</span> -->
                </p>
                <p></p>
              </CCol>
              <CCol sm="6" md="4">
                <p class="text-dark mb-0">
                  Accreditations :
                  <span
                    class="tags"
                    v-for="accreditations in centerData.general.accreditations"
                    :key="accreditations"
                  >
                    #{{ accreditations }}
                  </span>
                </p>
                <p></p>
              </CCol>
              <CCol sm="6" md="4">
                <p class="text-dark mb-0">Medical Tourism available : Yes</p>
                <p></p>
              </CCol>
              <CCol sm="6" md="4" class="cover-image">
                <p class="text-dark mb-0">Cover Image :</p>
                <div
                  class="file-attachment d-flex align-items-center"
                  @click="
                    openModal(centerData.general.cover_image, 'Cover Image')
                  "
                >
                  <fileSVG />
                  <p class="ml-2 mb-0 cursor"></p>
                </div>
              </CCol>
              <CCol sm="6" md="4">
                <p class="text-dark mb-0">
                  Other images of Hospital :
                  <button
                    type="button"
                    class="
                      view-hospital
                      v-btn v-btn--is-elevated v-btn--has-bg
                      theme--light
                      v-size--large
                    "
                    @click="showHospitalImages()"
                  >
                    <span class="v-btn__content">View</span>
                  </button>
                </p>
                <p></p>
              </CCol>
              <CCol sm="6" md="4">
                <p class="text-dark mb-0">
                  Description :{{ centerData.general.bio }}
                </p>
                <p></p>
              </CCol>
            </CRow>
          </CCol>
        </CCol>
        <!-- .... End Hospital Detail ... -->
        <!-- .... Ward Detail ... -->
        <CCol sm="12" class="px-0 pb-0">
          <CCol sm="12" class="pt-0 border-bottom">
            <h6 class="mb-0 text-dark">Ward Details</h6>
          </CCol>
          <CCol sm="12" class="border-bottom">
            <CRow>
              <CCol
                sm="6"
                md="4"
                v-for="(ward, index) in centerData.hospital.ward_details"
                :key="index"
              >
                <p class="text-dark mb-0">Ward Type : {{ ward.ward_type }}</p>
                <p class="text-dark mb-0">
                  No. of beds / rooms : {{ ward.total_beds }}
                </p>
                <p class="text-dark mb-0">
                  Charge / day : {{ ward.cost_per_bed }}
                </p>
                <p></p>
              </CCol>
            </CRow>
          </CCol>
        </CCol>
        <!-- .... End Ward Detail ... -->
        <!-- ...... Doctor Detail ...... -->
        <CCol sm="12" class="p-0">
          <CCol sm="12" class="border-bottom">
            <h6 class="mb-0 text-dark">Doctor Details</h6>
          </CCol>
          <CCol sm="12" class="border-bottom">
            <div class="doctor-summary-table mb-5">
              <table>
                <thead class="doc-bg">
                  <tr>
                    <th class="p-font font-weight-bold pl-4">Sr no.</th>
                    <th class="p-font font-weight-bold">Name</th>
                    <th class="p-font font-weight-bold">Mobile Number</th>
                    <th class="p-font font-weight-bold">Branch of Medicine</th>
                    <th class="p-font font-weight-bold">Speciality</th>
                    <th class="p-font font-weight-bold">Qualification</th>
                    <th class="p-font font-weight-bold">Empaneled on</th>
                  </tr>
                </thead>
                <tbody v-if="centerData.doctor && centerData.doctor.length">
                  <tr v-for="(doctor, i) in centerData.doctor" :key="i">
                    <td v-if="doctor._id" class="p-font text-default">
                      {{ i + 1 }}
                    </td>
                    <td class="p-font text-default" v-if="doctor._id">
                      {{ doctor.doctors_panel.full_name }}
                    </td>
                    <td class="p-font text-default" v-if="doctor._id">
                      {{ doctor.doctors_panel.mobile }}
                    </td>
                    <td class="p-font text-default" v-if="doctor._id">
                      {{ doctor.doctors_panel.branch_of_medicine }}
                    </td>
                    <td class="p-font text-default" v-if="doctor._id">
                      {{
                        doctor.doctors_panel.specialities &&
                          doctor.doctors_panel.specialities[0] &&
                          doctor.doctors_panel.specialities[0].speciality_type
                      }}
                    </td>
                    <td class="p-font text-default" v-if="doctor._id">
                      {{
                        doctor.doctors_panel &&
                          doctor.doctors_panel
                            .highest_qualification_to_display &&
                          doctor.doctors_panel.highest_qualification_to_display
                      }}

                      <span
                        v-if="
                          doctor.doctors_panel.highest_qualification &&
                            doctor.doctors_panel.highest_qualification.length >
                              0
                        "
                        class="d-block text-success font-weight-bold cursor pt-1"
                        @click="
                          setHighestQualifications(
                            doctor.doctors_panel.highest_qualification.length >
                              0
                              ? doctor.doctors_panel.highest_qualification
                              : []
                          )
                        "
                      >
                        +
                        {{ doctor.doctors_panel.highest_qualification.length }}
                        More</span
                      >
                    </td>
                    <td class="p-font text-default" v-if="doctor._id">
                      {{ doctor.created_at | formatDate }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!-- <CCol sm="6" md="4">
                <p class="text-dark mb-0">First Name : Deepak</p>
                <p></p>
              </CCol>
              <CCol sm="6" md="4">
                <p class="text-dark mb-0">Last Name : Baid</p>
                <p></p>
              </CCol>
              <CCol sm="6" md="4">
                <p class="text-dark mb-0">Mobile Number : 0987654321</p>
                <p></p>
              </CCol>
              <CCol sm="6" md="4">
                <p class="text-dark mb-0">Branch of Medicine :</p>
                <p></p>
              </CCol>
              <CCol sm="6" md="4">
                <p class="text-dark mb-0">Specialty :</p>
                <p></p>
              </CCol>
              <CCol sm="6" md="4">
                <p class="text-dark mb-0">Qualification :</p>
                <p></p>
              </CCol>
              <CCol sm="6" md="4">
                <p class="text-dark mb-0">In Practice Since :</p>
                <p></p>
              </CCol>
              <CCol sm="6" md="4">
                <p class="text-dark mb-0">Years Of Practice :</p>
                <p></p>
              </CCol> -->
          </CCol>
        </CCol>
        <!-- ...... end Address Info ...... -->
      </CCol>
    </CCol>

    <image-preview
      @close="closeImageModal"
      v-if="openImageModal"
      :openImageModal="openImageModal"
      :source="fileUrl"
      :fileArcheType="fileArcheType"
    ></image-preview>
    <light-box-new
      :images="lightboxImages"
      ref="lightbox"
      :showButtons="true"
      v-if="showImg"
    ></light-box-new>

    <!-- =============================================================== -->
    <!-- government health scheme  modal-->
    <v-dialog
      persistent
      content-class="modal-box"
      v-model="governmentHealthScheme"
      width="500"
    >
      <v-card class="min-height">
        <nav
          class="v-toolbar pt-0 pb-0 border-bottom shadow-none bg-fade"
          data-booted="true"
          style="
            margin-top: 0px;
            padding-right: 0px;
            padding-left: 0px;
            transform: translateY(0px);
          "
        >
          <div class="v-toolbar__content">
            <div
              class="v-toolbar__title font-weight-bold pl-0 pt-3 pb-2 pr-6 mob-title-space"
            >
              Government Health Scheme
            </div>
            <div class="spacer"></div>
            <button
              type="button"
              class="v-btn"
              @click="governmentHealthScheme = false"
            >
              <div class="v-btn__content cross-btn mr-2">
                <crossSVG />
              </div>
            </button>
          </div>
        </nav>
        <v-card-text>
          <p
            v-for="(scheme, index) in centerData.hospital
              .government_health_schemes_data"
            :key="index"
          >
            {{ scheme.scheme }}
          </p>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- =============================================================== -->

    <!-- highest qualification modal -->
    <highest-qualification-modal
      v-if="showHighestQualifications"
      :showHighestQualifications="showHighestQualifications"
      :selectedQualifications="selectedQualifications"
      @close="showHighestQualifications = false"
    ></highest-qualification-modal>

    <!-- =============================================================== -->
    <!-- cashless scheme  modal-->
    <v-dialog
      persistent
      content-class="modal-box"
      v-if="cashlessScheme"
      v-model="cashlessScheme"
      width="500"
    >
      <v-card class="min-height">
        <nav
          class="v-toolbar pt-0 pb-0 border-bottom shadow-none bg-fade"
          data-booted="true"
          style="
            margin-top: 0px;
            padding-right: 0px;
            padding-left: 0px;
            transform: translateY(0px);
          "
        >
          <div class="v-toolbar__content">
            <div
              class="v-toolbar__title font-weight-bold pl-0 pt-3 pb-2 pr-6 mob-title-space"
            >
              Cashless Services
            </div>
            <div class="spacer"></div>
            <button type="button" class="v-btn" @click="cashlessScheme = false">
              <div class="v-btn__content cross-btn mr-2">
                <crossSVG />
              </div>
            </button>
          </div>
        </nav>
        <v-card-text>
          <p
            v-for="(insurance, index) in centerData.hospital
              .insurance_companies_data"
            :key="index"
          >
            {{ insurance.name }}
          </p>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- =============================================================== -->
  </div>
</template>
<script>
import config from "@/config.js";
import { pickSvg } from "@/views/SVG";
import "@/assets/scss/_userDetails.scss";
const dayJS = require("@/methods/dayjs")
  .advancedFormat()
  .customParseFormat()
  .build();
import formats from "@/formats";
const highestQualificationsModal = () =>
  import("@/components/modals/highestQualifications.vue");
export default {
  props: ["centerId"],
  data() {
    return {
      lightboxImages: [],
      centerData: {},
      isEmpty: true,
      openImageModal: false,
      fileUrl: "",
      fileArcheType: "",
      dayJS,
      formats,
      showImg: false,
      governmentHealthScheme: false,
      cashlessScheme: false,
      dialog: false,
      dialog1: false,
      selectedQualifications: [],
      showHighestQualifications: false,
    };
  },
  components: {
    "light-box-new": () => import("@/components/lightBoxNew.vue"),
    "image-view": () => import("@/components/image.vue"),
    "image-preview": () => import("@/components/modals/imagePreview.vue"),
    "highest-qualification-modal": highestQualificationsModal,

    ...pickSvg("crossSVG", "fileSVG"),
    loader: () => import("@/components/loader.vue"),
  },

  mounted() {
    this.getHospitalDetails();
  },
  filters: {
    formatDate: (date) => {
      if (!date) return "-";
      return dayJS(date).format("DD/MM/YYYY");
    },
    age: (val) => {
      if (!val) return 0;
      return dayJS().diff(val, "years");
    },
    speciality: (val) => {
      if (!val) return "";
      let spec = "";
      val.map((s) => {
        spec = spec + s.speciality_type + " , ";
      });
      return spec;
    },
    // quailfication: (val) => {
    //   if (!val) return "";
    //   let spec = "";
    //   val.map((s) => {
    //     spec = spec + s + " , ";
    //   });
    //   return spec;
    // },
    services_offered: (val) => {
      if (!val) return "";
      let spec = "";
      val.map((s) => {
        spec = spec + s + " , ";
      });
      return spec;
    },
  },
  methods: {
    setHighestQualifications(qualifications) {
      this.selectedQualifications = qualifications;
      this.showHighestQualifications = true;
    },
    closeImageModal() {
      this.openImageModal = false;
    },
    openModal(fileUrl, fileArcheType) {
      this.fileUrl = fileUrl;
      this.fileArcheType = fileArcheType;
      this.openImageModal = true;
    },
    getHospitalDetails() {
      this.$store.commit("general/setLoader", true);
      let role = "hospital";
      let url = `${config.BASE_URL}api/v2/admin/centers/${this.centerId}/profile?role=${role}`;
      this.$http.get(url).then((response) => {
        if (response.body.status) {
          this.$store.commit("general/setLoader", false);
          this.centerData = response && response.body && response.body.data;
          for (let i in this.centerData.doctor) {
            if (
              this.centerData.doctor[i] &&
              this.centerData.doctor[i].doctors_panel &&
              this.centerData.doctor[i].doctors_panel.highest_qualification
            ) {
              this.centerData.doctor[
                i
              ].doctors_panel.highest_qualification = this.centerData.doctor[
                i
              ].doctors_panel.highest_qualification.filter(
                (word) => word !== "Other"
              );
              if (this.centerData.doctor[i].doctors_panel.other_qualification) {
                this.centerData.doctor[
                  i
                ].doctors_panel.highest_qualification.push(
                  this.centerData.doctor[i].doctors_panel.other_qualification
                );
              }
            }
          }
          this.lightboxImages = this.centerData.general.center_images.map(
            (el) => {
              return {
                src: el,
                thumb: el,
              };
            }
          );
          this.isEmpty = false;
        } else {
          this.$store.commit("general/setLoader", false);
          this.isEmpty = true;
        }
      });
    },
    showHospitalImages() {
      this.showImg = true;
      this.$refs.lightbox.showImage(0);
    },
  },
};
</script>

<style scoped>
.user-profile-info {
  padding-top: 0 !important;
}
.view-certificate,
.view-hospital {
  height: 22px !important;
  font-size: 12px !important;
}
.cover-image {
  display: flex !important;
  align-items: center !important;
}

table {
  font-size: 0.9em;
  width: 100%;
  border-collapse: collapse;
  overflow: auto;
}

th {
  text-align: left;
}

thead {
  font-weight: bold;
  color: #000;
  background: #e4e4e45e;
}

td,
th {
  padding: 1em 0.5em;
  vertical-align: middle;
}

td {
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  background: #fff;
  text-align: left;
}

.head {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}
</style>
